import { Routes, Route, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";

import Header from './components/Header';
import './App.css';
import { SignInButton } from './components/MsalComponents/SignInButton';
import UnauthenticatedPage from './containers/UnantheticatedPage';
import Home from './pages/Home';
import Settings from './pages/Settings';
import Session from './pages/Session';
import SidebarLayout from './components/layout/SidebarLayout';
import Glossary from './pages/Glossary';
import Prompts from './pages/Prompts';
import Multiscreen from './pages/Multiscreen';
import ArticleSummaries from './pages/ArticleSummaries';
import SectionSummaries from './pages/SectionSummaries';
import Summarizer from './pages/Summarizer';
import Tags from './pages/Tags';

import { getAllTranscriptionsAsync } from './redux/transcription';
import { clientID, tenantID } from "./constants/graphConstants";
import { ProtectedEntryPoint } from './components/MsalComponents/ProtectedEntryPoint';
import { useMsal } from '@azure/msal-react';


function RequireAuth({ children }) {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function App() {
  const dispatch = useDispatch();
  const { transcriptions } = useSelector(state => state.transcriptions);
  const [isInitialized, setIsInitialized] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal()
  



  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getAllTranscriptionsAsync());
      console.log("Authenticated, fetched transcriptions:", transcriptions);
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        console.log('Initializing MSAL instance...');
        await instance.initialize(); // <-- ADD THIS
        const result = await instance.handleRedirectPromise(); // <-- NOW SAFE TO CALL
        // acquireTokenSilent (used to get the backend API token) needs an
        // active account, and nothing set one before.
        const account =
          result?.account || instance.getActiveAccount() || instance.getAllAccounts()[0];
        if (account) instance.setActiveAccount(account);
        console.log('MSAL instance initialized.');
        setIsInitialized(true);
      } catch (error) {
        console.error('Error during MSAL initialization:', error);
        setIsInitialized(true);
      }
    };
  
    initializeMsal();
  }, [instance]);


  return (
    <Routes>
      <Route path="/" element={<ProtectedEntryPoint />}>
        <Route index element={<Home />} />
        <Route path="settings" element={<Settings />} />
        <Route path="glossary" element={<Glossary />} />
        <Route path="prompts" element={<Prompts />} />
        <Route path="tags" element={<Tags />} />
        <Route path="article-summaries" element={<ArticleSummaries />} />
        <Route path="section-summaries" element={<SectionSummaries />} />
        <Route path="summarizer" element={<Summarizer />} />
        <Route path="session/:id" element={<Session />} />
        <Route path="multiscreen/:sessionId?" element={<Multiscreen />} />
      </Route>
    </Routes>
  );
}

export default App;
